import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'
import cookie from '~/utils/cookie'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  // 首页
  {
    path: '/',
    component: () => import('../views/home/index.vue'),
    alias: 'portal'
  },
  {
    path: '/home',
    redirect: 'portal'
  },
  {
    path: '/jane',
    component: () => import('../views/jane/index.vue'),
    alias: '/xueshi-iJournal/jane'
  },
  {
    path: '/similarArticles',
    component: () => import('../views/similarArticle/index.vue')
  },
  // 搜索期刊列表页
  {
    path: '/search',
    component: () => import('../views/journal-search/index.vue'),
    alias: '/xueshi-iJournal/search'
  },
  // 赛特新思
  {
    path: '/citexs',
    component: () => import('../views/citexs/index.vue'),
    alias: '/xueshi-iJournal/citexs'
  },
  {
    // 期刊预警名单
    path: '/journal-warning-list',
    component: () => import('../views/journal-warning-list/index.vue'),
    alias: '/xueshi-iJournal/journal/journal-warning-list'
  },
  {
    // 期刊详情页面
    path: '/journal/:journalIssn',
    /*     meta: {
      authentication: false
    }, */
    component: () => import('../views/journal-details/index.vue'),
    alias: '/xueshi-iJournal/journal/:journalIssn'
  },
  {
    path: '/user',
    component: () => import('../views/user'),
    redirect: '/user/info',
    meta: {
      authentication: true
    },
    children: [
      {
        path: 'info',
        meta: {
          content: '个人信息'
        },
        component: () => import('../views/user/info')
      },
      {
        path: 'account',
        meta: {
          content: '修改密码'
        },
        component: () => import('../views/user/account')
      },
      {
        path: 'follow',
        meta: {
          content: '我的关注'
        },
        component: () => import('../views/user/follow'),
        alias: '/xueshi-iJournal/user/follow'
      },
      {
        path: 'comment',
        meta: {
          content: '我的评论'
        },
        component: () => import('../views/user/comment'),
        alias: '/xueshi-iJournal/user/comment'
      }
    ]
  },
  // 选刊指南
  {
    path: '/guide',
    component: () => import('../views/guide')
  },
  // 选刊详情页
  {
    path: '/guide/:id',
    component: () => import('../views/guide/details')
  },
  // 最新公告
  {
    path: '/notice',
    component: () => import('../views/notice')
  },
  // 公告详情页
  {
    path: '/notice/:id',
    component: () => import('../views/notice/detail')
  },
  {
    path: '/aboutus',
    component: () => import('../views/about-us')
  },
  {
    path: '/journal-cooperation',
    component: () => import('../views/journal-cooperation')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  // 百度统计代码
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  // 学识云
  if (to.path.indexOf('/xueshi-iJournal') === 0 && window.parent) {
    if (to.query.token) {
      cookie.set('xueshi-token', to.query.token)
    }
    window.parent.postMessage({
      type: 'router',
      path: to.fullPath
    }, parentOrigin)
  }
  if (to.matched.some(record => record.meta.authentication)) {
    let token = to.path.indexOf('/xueshi-iJournal') === 0 && window.parent ? cookie.get('xueshi-token') : cookie.get('T_j_web_token')
    if (token) {
      next()
    } else {
      if (to.path.indexOf('/xueshi-iJournal') === 0) {
        next('/xueshi-iJournal/home?login=xueshi')
      } else {
        next('/home?login=1')
      }
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  bar.finish()
})

export const parentOrigin = {
  'production': 'https://portal.xueshicloud.com',
  'lan': 'http://192.168.1.124:8062',
  'development': 'http://localhost:8062'
}[process.env.NODE_ENV]

export const ssoOrigin = {
  'production': 'https://sso.xueshicloud.com',
  'lan': 'http://192.168.1.124:8061',
  'development': 'http://localhost:8061'
}[process.env.NODE_ENV]

export default router



// WEBPACK FOOTER //
// ./src/router/index.js